import { PerformanceTest, PerformanceTestResult, AthleteTestBenchmark } from '../types';

// Define all performance tests across 4 categories
export const performanceTests: PerformanceTest[] = [
  // STRENGTH (Forza)
  { id: 'test-cmj', category: 'strength', name: 'CMJ (Countermovement Jump)', unit: 'cm', higherIsBetter: true },
  { id: 'test-dropjump', category: 'strength', name: 'Drop Jump', unit: 'cm', higherIsBetter: true },
  { id: 'test-dropjump-rsi', category: 'strength', name: 'Drop Jump RSI', unit: 'ratio', higherIsBetter: true },
  { id: 'test-1rm-squat', category: 'strength', name: '1RM Squat', unit: 'kg', higherIsBetter: true },
  { id: 'test-1rm-bench', category: 'strength', name: '1RM Bench Press', unit: 'kg', higherIsBetter: true },
  { id: 'test-1rm-deadlift', category: 'strength', name: '1RM Deadlift', unit: 'kg', higherIsBetter: true },
  { id: 'test-1rm-clean', category: 'strength', name: '1RM Clean', unit: 'kg', higherIsBetter: true },
  { id: 'test-1rm-snatch', category: 'strength', name: '1RM Snatch', unit: 'kg', higherIsBetter: true },
  { id: 'test-pullup', category: 'strength', name: 'Pull-up Max', unit: 'reps', higherIsBetter: true },
  { id: 'test-pushup', category: 'strength', name: 'Push-up Max', unit: 'reps', higherIsBetter: true },
  { id: 'test-plank', category: 'strength', name: 'Plank Hold', unit: 's', higherIsBetter: true },
  { id: 'test-legpress', category: 'strength', name: 'Leg Press', unit: 'kg', higherIsBetter: true },
  { id: 'test-handgrip', category: 'strength', name: 'Hand Grip', unit: 'kg', higherIsBetter: true },
  
  // SPEED (Velocità)
  { id: 'test-10m', category: 'speed', name: '10m Sprint', unit: 's', higherIsBetter: false },
  { id: 'test-20m', category: 'speed', name: '20m Sprint', unit: 's', higherIsBetter: false },
  { id: 'test-30m', category: 'speed', name: '30m Sprint', unit: 's', higherIsBetter: false },
  { id: 'test-40m', category: 'speed', name: '40m Sprint', unit: 's', higherIsBetter: false },
  { id: 'test-5-10-5', category: 'speed', name: '5-10-5 Agility', unit: 's', higherIsBetter: false },
  { id: 'test-t-test', category: 'speed', name: 'T-Test Agility', unit: 's', higherIsBetter: false },
  { id: 'test-illinois', category: 'speed', name: 'Illinois Agility', unit: 's', higherIsBetter: false },
  { id: 'test-flying10', category: 'speed', name: 'Flying 10m', unit: 's', higherIsBetter: false },
  { id: 'test-505', category: 'speed', name: '505 Agility', unit: 's', higherIsBetter: false },
  
  // ENDURANCE (Resistenza)
  { id: 'test-yoyo', category: 'endurance', name: 'Yo-Yo Test', unit: 'm', higherIsBetter: true },
  { id: 'test-vo2max', category: 'endurance', name: 'VO₂max (est.)', unit: 'ml/kg/min', higherIsBetter: true },
  { id: 'test-cooper', category: 'endurance', name: 'Cooper Test (12min)', unit: 'm', higherIsBetter: true },
  { id: 'test-beep', category: 'endurance', name: 'Beep Test', unit: 'level', higherIsBetter: true },
  { id: 'test-1500m', category: 'endurance', name: '1500m Run', unit: 's', higherIsBetter: false },
  { id: 'test-3000m', category: 'endurance', name: '3000m Run', unit: 's', higherIsBetter: false },
  { id: 'test-5000m', category: 'endurance', name: '5000m Run', unit: 's', higherIsBetter: false },
  { id: 'test-rast', category: 'endurance', name: 'RAST Test', unit: 'W', higherIsBetter: true },
  
  // BODY COMPOSITION (Composizione)
  { id: 'test-weight', category: 'bodyComposition', name: 'Weight', unit: 'kg', higherIsBetter: false },
  { id: 'test-height', category: 'bodyComposition', name: 'Height', unit: 'cm', higherIsBetter: false },
  { id: 'test-bodyfat', category: 'bodyComposition', name: 'Body Fat %', unit: '%', higherIsBetter: false },
  { id: 'test-leanmass', category: 'bodyComposition', name: 'Lean Mass', unit: 'kg', higherIsBetter: true },
  { id: 'test-bmi', category: 'bodyComposition', name: 'BMI', unit: 'kg/m²', higherIsBetter: false },
  { id: 'test-waist', category: 'bodyComposition', name: 'Waist Circumference', unit: 'cm', higherIsBetter: false },
  { id: 'test-skinfold', category: 'bodyComposition', name: 'Skinfold Sum', unit: 'mm', higherIsBetter: false },
];

// Mock performance test results - ALIGNED IDs '1', '2', '3', etc.
export const performanceTestResults: PerformanceTestResult[] = [
  // Athlete 1 - Full season coverage (June 2025 → February 2026 = 9 months)
  // Strength - 1RM Squat (10 data points)
  { id: 'ptr1a-pre1', athleteId: '1', testId: 'test-1rm-squat', date: '2025-06-10', value: 100, calculatedMetrics: { 'W/kg': 1.39 } },
  { id: 'ptr1a-pre2', athleteId: '1', testId: 'test-1rm-squat', date: '2025-07-12', value: 105, calculatedMetrics: { 'W/kg': 1.46 } },
  { id: 'ptr1a-pre3', athleteId: '1', testId: 'test-1rm-squat', date: '2025-08-14', value: 108, calculatedMetrics: { 'W/kg': 1.50 } },
  { id: 'ptr1a', athleteId: '1', testId: 'test-1rm-squat', date: '2025-09-15', value: 110, calculatedMetrics: { 'W/kg': 1.57 } },
  { id: 'ptr1b', athleteId: '1', testId: 'test-1rm-squat', date: '2025-10-15', value: 115, calculatedMetrics: { 'W/kg': 1.64 } },
  { id: 'ptr1c', athleteId: '1', testId: 'test-1rm-squat', date: '2025-11-18', value: 118, calculatedMetrics: { 'W/kg': 1.68 } },
  { id: 'ptr1d', athleteId: '1', testId: 'test-1rm-squat', date: '2025-12-20', value: 119, calculatedMetrics: { 'W/kg': 1.70 } },
  { id: 'ptr1', athleteId: '1', testId: 'test-1rm-squat', date: '2026-01-15', value: 120, calculatedMetrics: { 'W/kg': 1.71 } },
  { id: 'ptr2', athleteId: '1', testId: 'test-1rm-squat', date: '2026-02-10', value: 125, calculatedMetrics: { 'W/kg': 1.79 } },
  
  // Strength - 1RM Bench (9 data points)
  { id: 'ptr3a-pre1', athleteId: '1', testId: 'test-1rm-bench', date: '2025-06-10', value: 72 },
  { id: 'ptr3a-pre2', athleteId: '1', testId: 'test-1rm-bench', date: '2025-07-12', value: 75 },
  { id: 'ptr3a-pre3', athleteId: '1', testId: 'test-1rm-bench', date: '2025-08-14', value: 77 },
  { id: 'ptr3a', athleteId: '1', testId: 'test-1rm-bench', date: '2025-09-15', value: 78 },
  { id: 'ptr3b', athleteId: '1', testId: 'test-1rm-bench', date: '2025-10-15', value: 80 },
  { id: 'ptr3c', athleteId: '1', testId: 'test-1rm-bench', date: '2025-11-20', value: 82 },
  { id: 'ptr3d', athleteId: '1', testId: 'test-1rm-bench', date: '2025-12-22', value: 84 },
  { id: 'ptr3', athleteId: '1', testId: 'test-1rm-bench', date: '2026-01-15', value: 85 },
  { id: 'ptr4', athleteId: '1', testId: 'test-1rm-bench', date: '2026-02-10', value: 87 },
  
  // Strength - 1RM Deadlift (9 data points)
  { id: 'ptr4a-pre1', athleteId: '1', testId: 'test-1rm-deadlift', date: '2025-06-10', value: 125 },
  { id: 'ptr4a-pre2', athleteId: '1', testId: 'test-1rm-deadlift', date: '2025-07-12', value: 128 },
  { id: 'ptr4a-pre3', athleteId: '1', testId: 'test-1rm-deadlift', date: '2025-08-14', value: 132 },
  { id: 'ptr4a', athleteId: '1', testId: 'test-1rm-deadlift', date: '2025-09-15', value: 135 },
  { id: 'ptr4b', athleteId: '1', testId: 'test-1rm-deadlift', date: '2025-10-18', value: 138 },
  { id: 'ptr4b2', athleteId: '1', testId: 'test-1rm-deadlift', date: '2025-11-20', value: 140 },
  { id: 'ptr4c', athleteId: '1', testId: 'test-1rm-deadlift', date: '2025-12-22', value: 143 },
  { id: 'ptr4c2', athleteId: '1', testId: 'test-1rm-deadlift', date: '2026-01-15', value: 145 },
  { id: 'ptr4d', athleteId: '1', testId: 'test-1rm-deadlift', date: '2026-02-10', value: 150 },
  
  // Speed - 10m Sprint (10 data points)
  { id: 'ptr5a-pre1', athleteId: '1', testId: 'test-10m', date: '2025-06-15', value: 1.92 },
  { id: 'ptr5a-pre2', athleteId: '1', testId: 'test-10m', date: '2025-07-18', value: 1.90 },
  { id: 'ptr5a-pre3', athleteId: '1', testId: 'test-10m', date: '2025-08-20', value: 1.88 },
  { id: 'ptr5a', athleteId: '1', testId: 'test-10m', date: '2025-09-20', value: 1.85 },
  { id: 'ptr5b', athleteId: '1', testId: 'test-10m', date: '2025-10-20', value: 1.82 },
  { id: 'ptr5c', athleteId: '1', testId: 'test-10m', date: '2025-11-25', value: 1.80 },
  { id: 'ptr5d', athleteId: '1', testId: 'test-10m', date: '2025-12-18', value: 1.79 },
  { id: 'ptr5', athleteId: '1', testId: 'test-10m', date: '2026-01-20', value: 1.78 },
  { id: 'ptr6', athleteId: '1', testId: 'test-10m', date: '2026-02-12', value: 1.74 },
  
  // Speed - 30m Sprint (9 data points)
  { id: 'ptr7a-pre1', athleteId: '1', testId: 'test-30m', date: '2025-06-15', value: 4.38 },
  { id: 'ptr7a-pre2', athleteId: '1', testId: 'test-30m', date: '2025-07-18', value: 4.32 },
  { id: 'ptr7a-pre3', athleteId: '1', testId: 'test-30m', date: '2025-08-20', value: 4.28 },
  { id: 'ptr7a', athleteId: '1', testId: 'test-30m', date: '2025-09-20', value: 4.25 },
  { id: 'ptr7b', athleteId: '1', testId: 'test-30m', date: '2025-10-20', value: 4.20 },
  { id: 'ptr7c', athleteId: '1', testId: 'test-30m', date: '2025-11-25', value: 4.16 },
  { id: 'ptr7d', athleteId: '1', testId: 'test-30m', date: '2025-12-18', value: 4.14 },
  { id: 'ptr7', athleteId: '1', testId: 'test-30m', date: '2026-01-20', value: 4.12 },
  { id: 'ptr8', athleteId: '1', testId: 'test-30m', date: '2026-02-12', value: 4.08 },
  
  // Speed - 5-10-5 Agility (8 data points)
  { id: 'ptr8a-pre1', athleteId: '1', testId: 'test-5-10-5', date: '2025-06-15', value: 5.12 },
  { id: 'ptr8a-pre2', athleteId: '1', testId: 'test-5-10-5', date: '2025-07-18', value: 5.08 },
  { id: 'ptr8a-pre3', athleteId: '1', testId: 'test-5-10-5', date: '2025-09-20', value: 5.02 },
  { id: 'ptr8a', athleteId: '1', testId: 'test-5-10-5', date: '2025-10-20', value: 4.95 },
  { id: 'ptr8b', athleteId: '1', testId: 'test-5-10-5', date: '2025-11-25', value: 4.88 },
  { id: 'ptr8b2', athleteId: '1', testId: 'test-5-10-5', date: '2025-12-18', value: 4.85 },
  { id: 'ptr8c', athleteId: '1', testId: 'test-5-10-5', date: '2026-01-20', value: 4.82 },
  { id: 'ptr8d', athleteId: '1', testId: 'test-5-10-5', date: '2026-02-12', value: 4.76 },
  
  // Endurance - Yo-Yo Test (9 data points)
  { id: 'ptr9a-pre1', athleteId: '1', testId: 'test-yoyo', date: '2025-06-20', value: 1500 },
  { id: 'ptr9a-pre2', athleteId: '1', testId: 'test-yoyo', date: '2025-07-25', value: 1580 },
  { id: 'ptr9a-pre3', athleteId: '1', testId: 'test-yoyo', date: '2025-08-28', value: 1620 },
  { id: 'ptr9a', athleteId: '1', testId: 'test-yoyo', date: '2025-09-25', value: 1650 },
  { id: 'ptr9b', athleteId: '1', testId: 'test-yoyo', date: '2025-10-28', value: 1720 },
  { id: 'ptr9c', athleteId: '1', testId: 'test-yoyo', date: '2025-11-30', value: 1780 },
  { id: 'ptr9d', athleteId: '1', testId: 'test-yoyo', date: '2025-12-28', value: 1800 },
  { id: 'ptr9', athleteId: '1', testId: 'test-yoyo', date: '2026-01-25', value: 1820 },
  { id: 'ptr10', athleteId: '1', testId: 'test-yoyo', date: '2026-02-14', value: 1900 },
  
  // Endurance - VO2max (9 data points)
  { id: 'ptr11a-pre1', athleteId: '1', testId: 'test-vo2max', date: '2025-06-20', value: 47.2 },
  { id: 'ptr11a-pre2', athleteId: '1', testId: 'test-vo2max', date: '2025-07-25', value: 48.5 },
  { id: 'ptr11a-pre3', athleteId: '1', testId: 'test-vo2max', date: '2025-08-28', value: 49.0 },
  { id: 'ptr11a', athleteId: '1', testId: 'test-vo2max', date: '2025-09-25', value: 49.5 },
  { id: 'ptr11b', athleteId: '1', testId: 'test-vo2max', date: '2025-10-28', value: 50.8 },
  { id: 'ptr11c', athleteId: '1', testId: 'test-vo2max', date: '2025-11-30', value: 51.5 },
  { id: 'ptr11d', athleteId: '1', testId: 'test-vo2max', date: '2025-12-28', value: 52.0 },
  { id: 'ptr11', athleteId: '1', testId: 'test-vo2max', date: '2026-01-25', value: 52.3 },
  { id: 'ptr12', athleteId: '1', testId: 'test-vo2max', date: '2026-02-14', value: 53.8 },
  
  // Body Composition - Weight (10 data points)
  { id: 'ptr13a-pre1', athleteId: '1', testId: 'test-weight', date: '2025-06-05', value: 73.5 },
  { id: 'ptr13a-pre2', athleteId: '1', testId: 'test-weight', date: '2025-07-05', value: 73 },
  { id: 'ptr13a-pre3', athleteId: '1', testId: 'test-weight', date: '2025-08-05', value: 72.5 },
  { id: 'ptr13a', athleteId: '1', testId: 'test-weight', date: '2025-09-10', value: 72 },
  { id: 'ptr13b', athleteId: '1', testId: 'test-weight', date: '2025-10-10', value: 71.5 },
  { id: 'ptr13c', athleteId: '1', testId: 'test-weight', date: '2025-11-10', value: 71 },
  { id: 'ptr13d', athleteId: '1', testId: 'test-weight', date: '2025-12-10', value: 70.5 },
  { id: 'ptr13', athleteId: '1', testId: 'test-weight', date: '2026-01-10', value: 70 },
  { id: 'ptr14', athleteId: '1', testId: 'test-weight', date: '2026-02-10', value: 70 },
  
  // Body Composition - Body Fat % (10 data points)
  { id: 'ptr15a-pre1', athleteId: '1', testId: 'test-bodyfat', date: '2025-06-05', value: 15.8 },
  { id: 'ptr15a-pre2', athleteId: '1', testId: 'test-bodyfat', date: '2025-07-05', value: 15.2 },
  { id: 'ptr15a-pre3', athleteId: '1', testId: 'test-bodyfat', date: '2025-08-05', value: 14.8 },
  { id: 'ptr15a', athleteId: '1', testId: 'test-bodyfat', date: '2025-09-10', value: 14.2 },
  { id: 'ptr15b', athleteId: '1', testId: 'test-bodyfat', date: '2025-10-10', value: 13.8 },
  { id: 'ptr15c', athleteId: '1', testId: 'test-bodyfat', date: '2025-11-10', value: 13.2 },
  { id: 'ptr15d', athleteId: '1', testId: 'test-bodyfat', date: '2025-12-10', value: 12.8 },
  { id: 'ptr15', athleteId: '1', testId: 'test-bodyfat', date: '2026-01-10', value: 12.5 },
  { id: 'ptr16', athleteId: '1', testId: 'test-bodyfat', date: '2026-02-10', value: 11.8 },
  
  // Body Composition - Lean Mass (9 data points)
  { id: 'ptr16a-pre1', athleteId: '1', testId: 'test-leanmass', date: '2025-06-05', value: 61.0 },
  { id: 'ptr16a-pre2', athleteId: '1', testId: 'test-leanmass', date: '2025-07-05', value: 61.4 },
  { id: 'ptr16a-pre3', athleteId: '1', testId: 'test-leanmass', date: '2025-08-05', value: 61.6 },
  { id: 'ptr16a', athleteId: '1', testId: 'test-leanmass', date: '2025-09-10', value: 61.8 },
  { id: 'ptr16b', athleteId: '1', testId: 'test-leanmass', date: '2025-10-10', value: 62.1 },
  { id: 'ptr16c', athleteId: '1', testId: 'test-leanmass', date: '2025-12-10', value: 62.5 },
  { id: 'ptr16d', athleteId: '1', testId: 'test-leanmass', date: '2026-01-10', value: 62.8 },
  { id: 'ptr16e', athleteId: '1', testId: 'test-leanmass', date: '2026-02-10', value: 63.2 },
  
  // Athlete 2
  { id: 'ptr17', athleteId: '2', testId: 'test-1rm-squat', date: '2026-01-15', value: 100 },
  { id: 'ptr18', athleteId: '2', testId: 'test-1rm-squat', date: '2026-02-10', value: 105 },
  { id: 'ptr19', athleteId: '2', testId: 'test-10m', date: '2026-01-20', value: 1.85 },
  { id: 'ptr20', athleteId: '2', testId: 'test-10m', date: '2026-02-12', value: 1.82 },
  { id: 'ptr21', athleteId: '2', testId: 'test-yoyo', date: '2026-01-25', value: 1620 },
  { id: 'ptr22', athleteId: '2', testId: 'test-yoyo', date: '2026-02-14', value: 1680 },
  
  // Athlete 3
  { id: 'ptr23', athleteId: '3', testId: 'test-1rm-squat', date: '2026-01-15', value: 135 },
  { id: 'ptr24', athleteId: '3', testId: 'test-1rm-squat', date: '2026-02-10', value: 140 },
  { id: 'ptr25', athleteId: '3', testId: 'test-10m', date: '2026-01-20', value: 1.68 },
  { id: 'ptr26', athleteId: '3', testId: 'test-10m', date: '2026-02-12', value: 1.65 },
  { id: 'ptr27', athleteId: '3', testId: 'test-yoyo', date: '2026-01-25', value: 2100 },
  { id: 'ptr28', athleteId: '3', testId: 'test-yoyo', date: '2026-02-14', value: 2180 },
  
  // Athlete 4
  { id: 'ptr29', athleteId: '4', testId: 'test-1rm-squat', date: '2026-02-10', value: 115 },
  { id: 'ptr30', athleteId: '4', testId: 'test-10m', date: '2026-02-12', value: 1.76 },
  { id: 'ptr31', athleteId: '4', testId: 'test-yoyo', date: '2026-02-14', value: 1750 },
  
  // Athlete 5
  { id: 'ptr32', athleteId: '5', testId: 'test-1rm-squat', date: '2026-02-10', value: 95 },
  { id: 'ptr33', athleteId: '5', testId: 'test-10m', date: '2026-02-12', value: 1.92 },
  { id: 'ptr34', athleteId: '5', testId: 'test-yoyo', date: '2026-02-14', value: 1450 },
  
  // Athlete 7
  { id: 'ptr35', athleteId: '7', testId: 'test-1rm-squat', date: '2026-02-10', value: 110 },
  { id: 'ptr36', athleteId: '7', testId: 'test-10m', date: '2026-02-12', value: 1.80 },
  { id: 'ptr37', athleteId: '7', testId: 'test-yoyo', date: '2026-02-14', value: 1650 },
];

// Helper function to calculate benchmark statistics
export function calculateBenchmark(athleteId: string, testId: string, results: PerformanceTestResult[]): AthleteTestBenchmark {
  const athleteResults = results
    .filter(r => r.athleteId === athleteId && r.testId === testId)
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  
  if (athleteResults.length === 0) {
    return {
      athleteId,
      testId,
      personalBest: 0,
      baseline: 0,
      mean: 0,
      stdDev: 0,
      lastValue: 0,
      trend: 'stable'
    };
  }
  
  const test = performanceTests.find(t => t.id === testId)!;
  const values = athleteResults.map(r => r.value);
  
  const personalBest = test.higherIsBetter ? Math.max(...values) : Math.min(...values);
  const baseline = values[0];
  const lastValue = values[values.length - 1];
  const mean = values.reduce((a, b) => a + b, 0) / values.length;
  
  // Calculate standard deviation
  const squareDiffs = values.map(value => Math.pow(value - mean, 2));
  const avgSquareDiff = squareDiffs.reduce((a, b) => a + b, 0) / squareDiffs.length;
  const stdDev = Math.sqrt(avgSquareDiff);
  
  // Determine trend (comparing last 2 results if available)
  let trend: 'improving' | 'declining' | 'stable' = 'stable';
  if (values.length >= 2) {
    const secondLast = values[values.length - 2];
    const improvement = test.higherIsBetter 
      ? lastValue > secondLast 
      : lastValue < secondLast;
    const decline = test.higherIsBetter 
      ? lastValue < secondLast 
      : lastValue > secondLast;
    
    const changePercent = Math.abs((lastValue - secondLast) / secondLast * 100);
    if (changePercent > 2) { // 2% threshold for significance
      trend = improvement ? 'improving' : decline ? 'declining' : 'stable';
    }
  }
  
  return {
    athleteId,
    testId,
    personalBest,
    baseline,
    mean,
    stdDev,
    lastValue,
    trend
  };
}

// Generate benchmarks for all athletes and tests
export const athleteBenchmarks: AthleteTestBenchmark[] = [];
const athleteIds = ['1', '2', '3', '4', '5', '6', '7', '8'];
performanceTests.forEach(test => {
  athleteIds.forEach(athleteId => {
    const benchmark = calculateBenchmark(athleteId, test.id, performanceTestResults);
    if (benchmark.lastValue > 0) {
      athleteBenchmarks.push(benchmark);
    }
  });
});

// Calculate team percentiles for each test at a specific date
export function calculatePercentile(athleteId: string, testId: string, date: string, allResults: PerformanceTestResult[]): number {
  const test = performanceTests.find(t => t.id === testId);
  if (!test) return 0;
  
  // Get all results for this test on this date
  const dateResults = allResults.filter(r => r.testId === testId && r.date === date);
  
  if (dateResults.length === 0) return 0;
  
  const athleteResult = dateResults.find(r => r.athleteId === athleteId);
  if (!athleteResult) return 0;
  
  // Sort by value
  const sorted = [...dateResults].sort((a, b) => 
    test.higherIsBetter ? b.value - a.value : a.value - b.value
  );
  
  // Find rank (1-based)
  const rank = sorted.findIndex(r => r.id === athleteResult.id) + 1;
  
  // Convert to percentile
  return Math.round((1 - (rank - 1) / sorted.length) * 100);
}

// Calculate delta vs previous test
export function calculateDeltaPrevious(athleteId: string, testId: string, date: string, allResults: PerformanceTestResult[]): number | null {
  const athleteResults = allResults
    .filter(r => r.athleteId === athleteId && r.testId === testId)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  
  const currentIndex = athleteResults.findIndex(r => r.date === date);
  if (currentIndex === -1 || currentIndex === athleteResults.length - 1) return null;
  
  const current = athleteResults[currentIndex];
  const previous = athleteResults[currentIndex + 1];
  
  return current.value - previous.value;
}

// Calculate delta vs baseline (first test of the season)
export function calculateDeltaBaseline(athleteId: string, testId: string, date: string, allResults: PerformanceTestResult[]): number | null {
  const athleteResults = allResults
    .filter(r => r.athleteId === athleteId && r.testId === testId)
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  
  if (athleteResults.length === 0) return null;
  
  const baseline = athleteResults[0];
  const current = athleteResults.find(r => r.date === date);
  
  if (!current) return null;
  
  return current.value - baseline.value;
}